// @ts-ignore - no types available
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
/**
 * @constant {Object}
 * @desc Search input placeholder text by vertical.
 */

export var PLACEHOLDER = {
  CREDIT_CARDS: 'Search card name',
  PERSONAL_LOANS: 'Search lender name'
};
/**
 * Returns customized error messages by product type.
 *
 * @param inputValue - current user input
 * @param productType
 */

export var getErrorMessage = function getErrorMessage(inputValue, productType) {
  var errorMessage;

  switch (productType) {
    case PRODUCT_TYPES.CREDIT_CARDS:
      errorMessage = "We couldn't find credit cards for \"".concat(inputValue, "\". Please try something else.");
      break;

    case PRODUCT_TYPES.PERSONAL_LOANS:
      errorMessage = "We couldn't find lenders for \"".concat(inputValue, "\". Please try something else.");
      break;

    default:
      errorMessage = "We couldn't find results for \"".concat(inputValue, "\". Please try something else.");
      break;
  }

  return errorMessage;
};
/**
 * @constant {Object}
 * @desc Named queries.
 */

export var NAMED_QUERY = {
  CREDIT_CARDS: 'cc_autocomplete_active',
  PERSONAL_LOANS: 'personal_loans_autocomplete_active'
};
/**
 * @constant {Object}
 * @desc Marketplace fields.
 */

export var OFFER_FIELD = {
  DETAIL_POPULARITY_RANK: 'offer.details.popularity_rank',
  DETAILS_SLUG: 'offer.details.slug',
  NAME: 'offer.name',
  PRODUCT_INSTITUTION_NAME: 'offer.product.institution.name',
  PRODUCT_NAME: 'offer.product.name'
};